module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package-config"
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('div', {
    staticClass: "package-cover-block"
  }, [_c('div', {
    staticClass: "package-cover-head pkg-field-row pkg-field-row--cover-title"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "detail-title-hint detail-title-hint--after-label"
  }, [_vm._v(_vm._s(_vm.packageImageHintText))])]), _vm._v(" "), _c('div', {
    staticClass: "package-cover-upload-wrap"
  }, [(_vm.imagesEditable) ? _c('SUpload', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1",
      "headers": _vm.uploadAuthHeaders,
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false
    },
    model: {
      value: (_vm.packageData.coverUrl),
      callback: function($$v) {
        _vm.$set(_vm.packageData, "coverUrl", $$v)
      },
      expression: "packageData.coverUrl"
    }
  }) : (_vm.packageData && _vm.packageData.coverUrl) ? _c('div', {
    staticClass: "match-upload-preview-box match-upload-preview-box--view",
    on: {
      "click": function($event) {
        return _vm.$emit('preview-image', _vm.packageData.coverUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.packageData.coverUrl,
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "match-upload-empty-view"
  }, [_vm._v("暂无图片")])], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "pkg-field-item",
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "pkg-field-row"
  }, [_c('span', {
    staticClass: "pkg-field-label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("套餐标题")]), _vm._v(" "), _c('div', {
    staticClass: "pkg-field-body"
  }, [_c('el-input', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请输入套餐标题，不超过20个字",
      "maxlength": 20,
      "show-word-limit": "",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.packageData.packageTitle),
      callback: function($$v) {
        _vm.$set(_vm.packageData, "packageTitle", $$v)
      },
      expression: "packageData.packageTitle"
    }
  })], 1)])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "pkg-field-item",
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "pkg-field-row"
  }, [_c('span', {
    staticClass: "pkg-field-label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("套餐价格")]), _vm._v(" "), _c('div', {
    staticClass: "pkg-field-body"
  }, [_c('div', {
    staticClass: "inline-form-row"
  }, [_c('el-radio-group', {
    staticClass: "pace-radio-group",
    attrs: {
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.packageData.priceType),
      callback: function($$v) {
        _vm.$set(_vm.packageData, "priceType", $$v)
      },
      expression: "packageData.priceType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("免费")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("付费")])], 1), _vm._v(" "), (_vm.packageData.priceType === 2) ? [_c('el-input', {
    ref: "priceInput",
    staticStyle: {
      "width": "120px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入套餐价格，最多两位小数",
      "disabled": _vm.readonly
    },
    on: {
      "input": _vm.onPriceInput,
      "blur": _vm.onPriceBlur
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.onPriceKeydown.apply(null, arguments)
      },
      "paste": function($event) {
        $event.preventDefault();
        return _vm.onPricePaste.apply(null, arguments)
      },
      "compositionend": function($event) {
        return _vm.onPriceCompositionEnd.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.packageData.price),
      callback: function($$v) {
        _vm.$set(_vm.packageData, "price", $$v)
      },
      expression: "packageData.price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "price-unit"
  }, [_vm._v("元")])] : _vm._e()], 2)])])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "pkg-field-item",
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "pkg-field-row"
  }, [_c('span', {
    staticClass: "pkg-field-label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("限量类型")]), _vm._v(" "), _c('div', {
    staticClass: "pkg-field-body"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.packageData.limitType),
      callback: function($$v) {
        _vm.$set(_vm.packageData, "limitType", $$v)
      },
      expression: "packageData.limitType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("套餐限量")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("奖品限量")])], 1)], 1)])]), _vm._v(" "), (!_vm.readonly) ? _c('el-form-item', {
    staticClass: "pkg-field-item",
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "pkg-field-row"
  }, [_c('span', {
    staticClass: "pkg-field-label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("关联奖品")]), _vm._v(" "), _c('div', {
    staticClass: "pkg-field-body"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.onRelatePrize
    }
  }, [_vm._v("去关联")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.packageData.prizeList.length > 0) ? _c('el-form-item', {
    staticClass: "pkg-field-item",
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "pkg-field-row"
  }, [_c('span', {
    staticClass: "pkg-field-spacer",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pkg-field-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.packageData.prizeList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "prizeId",
      "label": "奖品ID",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeName",
      "label": "奖品名称",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "奖品类型",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.getPrizeTypeLabel(scope.row.prizeType)))]
      }
    }], null, false, 3870244524)
  }), _vm._v(" "), (_vm.packageData.limitType === 2) ? _c('el-table-column', {
    attrs: {
      "label": "报名限量（指前X个报名的用户可获得奖励）",
      "min-width": "280",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cell-inline"
        }, [_c('el-radio-group', {
          attrs: {
            "disabled": _vm.readonly
          },
          model: {
            value: (scope.row.signLimitType),
            callback: function($$v) {
              _vm.$set(scope.row, "signLimitType", $$v)
            },
            expression: "scope.row.signLimitType"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_vm._v("限量")])], 1), _vm._v(" "), (scope.row.signLimitType === 1) ? _c('el-input', {
          staticStyle: {
            "width": "120px",
            "margin-left": "6px"
          },
          attrs: {
            "placeholder": "请输入整数",
            "disabled": _vm.readonly
          },
          on: {
            "input": function (val) { return _vm.onSignLimitInput(val, scope.row); }
          },
          nativeOn: {
            "keydown": function($event) {
              return _vm.onSignLimitKeydown.apply(null, arguments)
            },
            "paste": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.onSignLimitPaste(e, scope.row); }).apply(null, arguments)
            },
            "compositionend": function($event) {
              return (function (e) { return _vm.onSignLimitCompositionEnd(e, scope.row); }).apply(null, arguments)
            }
          },
          model: {
            value: (scope.row.signLimit),
            callback: function($$v) {
              _vm.$set(scope.row, "signLimit", $$v)
            },
            expression: "scope.row.signLimit"
          }
        }) : _vm._e()], 1)]
      }
    }], null, false, 4005859555)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否活动限定",
      "min-width": "300",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cell-inline"
        }, [_c('el-radio-group', {
          attrs: {
            "disabled": _vm.readonly
          },
          model: {
            value: (scope.row.activityLimitType),
            callback: function($$v) {
              _vm.$set(scope.row, "activityLimitType", $$v)
            },
            expression: "scope.row.activityLimitType"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_vm._v("是")])], 1), _vm._v(" "), (scope.row.activityLimitType === 1) ? _c('el-input', {
          staticStyle: {
            "width": "150px",
            "margin-left": "6px"
          },
          attrs: {
            "placeholder": "请输入标签名",
            "maxlength": 10,
            "show-word-limit": "",
            "disabled": _vm.readonly
          },
          model: {
            value: (scope.row.activityLimit),
            callback: function($$v) {
              _vm.$set(scope.row, "activityLimit", $$v)
            },
            expression: "scope.row.activityLimit"
          }
        }) : _vm._e()], 1)]
      }
    }], null, false, 2595678114)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否隐藏(报名页及待支付页不显示)",
      "min-width": "300",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cell-inline"
        }, [_c('el-radio-group', {
          attrs: {
            "disabled": _vm.readonly
          },
          model: {
            value: (scope.row.isHide),
            callback: function($$v) {
              _vm.$set(scope.row, "isHide", $$v)
            },
            expression: "scope.row.isHide"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0,
            "value": 0
          }
        }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1,
            "value": 1
          }
        }, [_vm._v("是")])], 1)], 1)]
      }
    }], null, false, 1018628121)
  }), _vm._v(" "), (!_vm.readonly) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "color": "#f56c6c"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removePrize(scope.$index)
            }
          }
        }, [_vm._v("取消关联")])]
      }
    }], null, false, 762490306)
  }) : _vm._e()], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.packageData.limitType === 1) ? _c('el-form-item', {
    staticClass: "pkg-field-item",
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "pkg-field-row"
  }, [_c('span', {
    staticClass: "pkg-field-label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("套餐库存")]), _vm._v(" "), _c('div', {
    staticClass: "pkg-field-body"
  }, [_c('div', {
    staticClass: "inline-form-row"
  }, [_c('el-radio-group', {
    staticClass: "pace-radio-group",
    attrs: {
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.packageData.stockType),
      callback: function($$v) {
        _vm.$set(_vm.packageData, "stockType", $$v)
      },
      expression: "packageData.stockType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不限量")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("限量")])], 1), _vm._v(" "), (_vm.packageData.stockType === 1) ? _c('el-input', {
    ref: "stockInput",
    staticStyle: {
      "width": "120px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入库存数量",
      "disabled": _vm.readonly
    },
    on: {
      "input": _vm.onStockInput
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.onStockKeydown.apply(null, arguments)
      },
      "paste": function($event) {
        $event.preventDefault();
        return _vm.onStockPaste.apply(null, arguments)
      },
      "compositionend": function($event) {
        return _vm.onStockCompositionEnd.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.packageData.stock),
      callback: function($$v) {
        _vm.$set(_vm.packageData, "stock", $$v)
      },
      expression: "packageData.stock"
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.hasPhysicalPrize) ? _c('el-form-item', {
    staticClass: "pkg-field-item",
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "pkg-field-row"
  }, [_c('span', {
    staticClass: "pkg-field-label pkg-field-label--wide"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("实物奖励发货时限")]), _vm._v(" "), _c('div', {
    staticClass: "pkg-field-body"
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "请选择发货时限",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.packageData.deliveryDeadline),
      callback: function($$v) {
        _vm.$set(_vm.packageData, "deliveryDeadline", $$v)
      },
      expression: "packageData.deliveryDeadline"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "完赛后7个工作日内",
      "value": "完赛后7个工作日内"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "完赛后15个工作日内",
      "value": "完赛后15个工作日内"
    }
  })], 1)], 1)])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pkg-field-label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("套餐图片")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9c548bd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/onlineMatch/PackageConfig.vue
// module id = 1107
// module chunks = 0